window.env = {
  ENABLE_SPEECH: "true",
};

export const env = {
  ...process.env,
  ...window.env,
};
